import { render, staticRenderFns } from "./partial.basic_info.vue?vue&type=template&id=1177b414&scoped=true&"
import script from "./partial.basic_info.vue?vue&type=script&lang=js&"
export * from "./partial.basic_info.vue?vue&type=script&lang=js&"
import style0 from "./partial.basic_info.vue?vue&type=style&index=0&id=1177b414&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1177b414",
  null
  
)

export default component.exports